import { render, staticRenderFns } from "./TrxClient.vue?vue&type=template&id=12b87f40&"
import script from "./TrxClient.vue?vue&type=script&lang=js&"
export * from "./TrxClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrxClient.vue"
export default component.exports